import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { firstValueFrom, map, Observable, take } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  userDetail: any;
  localStorageWishlist: any;

  constructor(
    private afs: AngularFirestore,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.userDetails();
  }

  public userDetails() {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem("userData")) {
        let user =
          JSON.parse(window.atob(sessionStorage.getItem("userData"))) || {};
        this.userDetail = user;
      } else {
        this.userDetail = null;
      }
    }
  }

  async getHomeBannerService() {
    const getCollection = await this.afs.collection(
      `homeBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getCategoryService() {
    const getCollection = await this.afs.collection(
      `categoryMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getPopularBannerService() {
    const getCollection = await this.afs.collection(
      `popularCollectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getExclusiveBannerService() {
    const getCollection = await this.afs.collection(
      `exclusiveCollectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getFeaturedBannerService() {
    const getCollection = await this.afs.collection(
      `featuredCollectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getLatestBannerService() {
    const getCollection = await this.afs.collection(
      `latestCollectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getOtherBannerService() {
    const getCollection = await this.afs.collection(
      `otherCollectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getCollectionBannerService() {
    const getCollection = await this.afs.collection(
      `collectionBannerMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getCollectionService() {
    const getCollection = await this.afs.collection(
      `collectionMaster/`,
      (res) => {
        return res.orderBy("createdOn", "desc");
      }
    );
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getIllustrationService() {
    return this.afs
      .collection(`filesMaster`, (ref) =>
        ref.where("status", "==", "Published").orderBy("createdOn", "desc")
      )
      .valueChanges({ idField: "id" })
      .pipe(
        map((docs: any[]) =>
          docs.map((doc) => ({
            id: doc.id,
            title: doc.title,
            jpeg: doc.jpeg,
            png: doc.png,
            slug: doc.slug,
            thumb: doc.thumb,
            previewUrl: doc.previewUrl,
            createdOn: doc.createdOn,
            isPremium: doc.isPremium,
            isPopular: doc.isPopular,
            isExclusive: doc.isExclusive,
            isAIIllustration: doc.isAIIllustration ?? false,
            metadata: doc.metadata ?? [],
          }))
        )
      );
  }

  async getAIIllustrationService() {
    return this.afs
      .collection(`filesMaster`, (ref) =>
        ref
          .where("isAIIllustration", "==", true)
          .where("status", "==", "Published")
          .orderBy("createdOn", "desc")
      )
      .valueChanges({ idField: "id" })
      .pipe(
        map((docs: any[]) =>
          docs.map((doc) => ({
            id: doc.id,
            title: doc.title,
            jpeg: doc.jpeg,
            png: doc.png,
            slug: doc.slug,
            thumb: doc.thumb,
            previewUrl: doc.previewUrl,
            createdOn: doc.createdOn,
            isPremium: doc.isPremium,
            isPopular: doc.isPopular,
            isExclusive: doc.isExclusive,
            isAIIllustration: doc.isAIIllustration,
            metadata: doc.metadata ?? [],
          }))
        )
      );
  }

  async getIllustrationPopularService() {
    const getCollection = await this.afs.collection(`filesMaster/`, (res) => {
      return res
        .where("isPopular", "==", true)
        .where("status", "==", "Published")
        .orderBy("createdOn", "desc");
    });
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  async getAIIllustrationPopularService() {
    const getCollection = await this.afs.collection(`filesMaster/`, (res) => {
      return res
        .where("isAIIllustration", "==", true)
        .where("isPopular", "==", true)
        .where("status", "==", "Published")
        .orderBy("createdOn", "desc");
    });
    const getCollectionData = await getCollection.valueChanges({
      idField: "id",
    });
    return getCollectionData;
  }

  // Adding new Product to Wishlist in localStorage
  public async addToWishlist(data: any, userId: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    let wishlist = JSON.parse(sessionStorage.getItem("wishlist_item")) || [];

    wishlist = await this.cleanStaleFavorites(wishlist);

    const exists = wishlist.some((item) => item.id === data.id);

    if (exists) {
      wishlist = wishlist.filter((item) => item.id !== data.id);
    } else {
      wishlist.push(data);
    }

    sessionStorage.setItem("wishlist_item", JSON.stringify(wishlist));

    await this.afs.doc(`/userMaster/${userId}`).update({
      favorites: wishlist,
    });

    this.getandsetUserData(userId);
    return wishlist;
  }

  private async cleanStaleFavorites(favorites: any[]) {
    const cleaned: any[] = [];

    for (let item of favorites) {
      const snap = await this.afs.doc(`filesMaster/${item.id}`).ref.get();
      if (snap.exists) cleaned.push(item); // keep only valid items
    }

    return cleaned;
  }

  public async getandsetUserData(id) {
    const admin = await this.afs.doc(`userMaster/${id}`);
    admin
      .valueChanges()
      .pipe(take(1))
      .subscribe(async (data) => {
        //console.log(data);
        if (isPlatformBrowser(this.platformId)) {
          this.userDetail = data;
          sessionStorage.setItem("userData", window.btoa(JSON.stringify(data)));
        }
      });
  }

  // Removing Wishlist from local
  public removeLocalWishlistProduct(product: any, id) {
    if (isPlatformBrowser(this.platformId)) {
      let illustrations: any = JSON.parse(
        sessionStorage.getItem("wishlist_item")
      );

      for (let i = 0; i < illustrations.length; i++) {
        if (illustrations[i].id === product.id) {
          illustrations.splice(i, 1);
          break;
        }
      }

      sessionStorage.setItem("wishlist_item", JSON.stringify(illustrations));
      let fav = [];
      fav = [...illustrations];
      const document = this.afs.doc("/userMaster/" + id);
      document.update({ favorites: fav });
      this.getandsetUserData(id);
    }
  }

  // Removing Wishlist from local
  public getWishlistItems() {
    if (isPlatformBrowser(this.platformId)) {
      let illustrations: any =
        JSON.parse(sessionStorage.getItem("wishlist_item")) || [];

      return illustrations;
    }
  }

  async getdownloadHistoryByDateService(date, id) {
    const getUnit = await this.afs.collection(
      `downloadHistroyMaster/`,
      (res) => {
        return res
          .where("downloadedDate", "==", date)
          .where("uid", "==", id)
          .orderBy("createdOn", "desc");
      }
    );
    const getUnitData = await getUnit.valueChanges({ idField: "id" });
    return getUnitData;
  }

  async getdownloadHistoryByIDService(id) {
    const getUnit = await this.afs.collection(
      `downloadHistroyMaster/`,
      (res) => {
        return res.where("uid", "==", id).orderBy("createdOn", "desc");
      }
    );
    const getUnitData = await getUnit.valueChanges({ idField: "id" });
    return getUnitData;
  }

  async getdownloadLimitationService() {
    const getUnit = await this.afs.collection(`limitCollection/`, (res) => {
      return res;
    });
    const getUnitData = await getUnit.valueChanges({ idField: "id" });
    return getUnitData;
  }

  async getPaymentAmountService() {
    const getUnit = await this.afs.collection(`priceMaster/`, (res) => {
      return res;
    });
    const getUnitData = await getUnit.valueChanges({ idField: "id" });
    return getUnitData;
  }

  generateSlug(title: string): string {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-") // replace non-alphanumeric with -
      .replace(/^-+|-+$/g, ""); // remove leading/trailing hyphens
  }
}
